module.exports = {
	"articleTitle1": "Personal Statement: A plea for common courtesy ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "The Common Cup",
	"articleLink1": "#",
	"articleLink2": "http://www.michigandaily.com/content/students-ignorance-leads-binge-drinking",
	"articleSnippet1": "Oct 20, 2015 ... Personal Statement: A plea for common courtesy . Illustration ... I am carrying hot \nfood, cups filled to the brim with liquid, and knives. Your child ...",
	"articleSnippet2": "Nov 18, 2003 ... their cup. By pouring more alcohol into larger-size cups, students may be ... LSA \nsenior Kendon Wilson recalled a common party experience.",
	"foodRecommendations": [],
	"articleTitle2": "Students' ignorance leads to binge drinking",
	"address": "1511 Washtenaw Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2739,
		"lng": -83.7285
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/commoncup.json
// module id = 854
// module chunks = 0